import React from "react";
import { Logo } from "@/components/shared/Logo";
import { LanguageSwitcher } from "@/components/shared/LanguageSwitcher";
import { Link } from "react-router-dom";

export function AuthShell({ title, subtitle, children }) {
  return (
    <div className="min-h-screen bg-brand-navy flex flex-col radial-cyan">
      <div className="flex items-center justify-between px-6 py-5">
        <Logo size="h-8" />
        <LanguageSwitcher />
      </div>
      <div className="flex-1 flex items-center justify-center px-4 py-8">
        <div className="w-full max-w-md animate-fade-up">
          <div className="card-surface glass rounded-2xl p-7 sm:p-9">
            <h1 className="font-display text-2xl font-bold text-white">{title}</h1>
            {subtitle && <p className="mt-2 text-sm text-slate-400">{subtitle}</p>}
            <div className="mt-7">{children}</div>
          </div>
          <p className="mt-6 text-center text-xs text-slate-600">
            <Link to="/" className="hover:text-brand-cyan">← Back to INVIXA</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
